"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initPermissions = exports.$$overridePermissionsForTesting = exports.$canOrg = exports.$canSub = exports.$can = void 0;
var permissions_1 = require("./permissions");
// Export methods for tests
function $$overridePermissionsForTesting(accessControl, altEvalFn) {
    if (!pendoPermissions) {
        initPermissions(accessControl, altEvalFn);
    }
    else {
        pendoPermissions.overridePermissions(accessControl, altEvalFn);
    }
}
exports.$$overridePermissionsForTesting = $$overridePermissionsForTesting;
var emptyAccessControl = {
    applicationAccessControl: {},
    subscriptionAccessControl: []
};
var pendoPermissions = null;
/**
 * Method used to initialize permissions with `accessControl` {@link AccessControl}
 * @param accessControl data received from BE on init {@link AccessControl}
 * @param altEvalFn optional logic to run in BaseFeatureArea.evalPermission {@link AltPermissionEval}
 * @internal handle assigning new/additional methods here
 */
function initPermissions(accessControl, altEvalFn) {
    if (!accessControl) {
        accessControl = emptyAccessControl;
    }
    if (!pendoPermissions) {
        pendoPermissions = new permissions_1.Permissions(accessControl, altEvalFn);
        exports.$can = pendoPermissions.$can.bind(pendoPermissions);
        exports.$canSub = pendoPermissions.$canSub.bind(pendoPermissions);
        exports.$canOrg = pendoPermissions.$canOrg.bind(pendoPermissions);
    }
    else {
        // tslint:disable-next-line
        console.warn('Pendo permissions have already been initialized, call to `initPermissions` ignored');
    }
}
exports.initPermissions = initPermissions;
